import { questsSearchSchema } from '@/features/quests/use-quests-launch'
import { storeSearchSchema } from '@/features/store/use-store-launch'
import { createRootRoute, Outlet } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { Page404 } from '@/routes/-404/404'
import { Utms } from '@/features/utms/utms'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { z } from 'zod'

export const Route = createRootRoute({
  component: function RootRouteComponent() {
    return (
      <>
        <Outlet />
        <Utms />
        <TanStackRouterDevtools />
      </>
    )
  },
  validateSearch: zodValidator(
    storeSearchSchema.merge(questsSearchSchema).merge(
      z.object({
        amoe: z.literal('postal-request-code').optional(),
        'game-info': z.string().optional(),
        'category-name': z.string().optional(),
        'category-id': z.string().optional(),
        redeem: z.literal(true).optional(),
      }),
    ),
  ),
  notFoundComponent: Page404,
})
